export const getDocuments = ({
  token,
  page,
  sortBy,
  sortDirection,
  search,
  filters,
}) => {
  const params = new URLSearchParams({
    page,
    sortBy,
    sortDirection,
    search,
    ...filters,
  }).toString()
  return fetch(`${process.env.GATSBY_FUNCTION_PATH}/get-documents?${params}`, {
    method: 'GET',
    headers: {
      token,
    },
  })
}

export const createEipDocument = ({token, document}) => {
  return fetch(`${process.env.GATSBY_FUNCTION_PATH}/create-document`, {
    method: 'POST',
    body: JSON.stringify(document),
    headers: {
      token,
    },
  })
}

export const uploadFilePreflight = ({
  name,
  accessToken,
  destinationFolder,
  file,
}) =>
  fetch(`${process.env.GATSBY_BOX_API_URL}/files/content/`, {
    method: 'OPTIONS',
    headers: {
      Authorization: `Bearer ${accessToken.accessToken}`,
    },
    body: JSON.stringify({
      name,
      parent: {
        id: destinationFolder,
      },
      size: file.size,
    }),
  })

export const uploadFile = ({uploadUrl, accessToken, formData}) =>
  fetch(uploadUrl, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken.accessToken}`,
    },
    body: formData,
  })

export const deleteDocument = ({fileId, token, skipFile}) => {
  const params = new URLSearchParams({
    fileId,
    skipFile,
  }).toString()
  return fetch(
    `${process.env.GATSBY_FUNCTION_PATH}/delete-document?${params}`,
    {
      method: 'DELETE',
      headers: {
        token,
      },
    },
  )
}
